import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../Card/CardHeaderCommon";
// import { P } from "../../../../AbstractElements";

interface SpanType {
  text: string; // Ensure this matches the actual data structure
}

interface CustomCardProps {
  title: string;
  content: React.ReactNode; // ✅ Accepts JSX, strings, or components
  spanData?: SpanType[];
  headClass?: string;
  colSize?: string;
  style?:React.CSSProperties;
}

const CustomCard: React.FC<CustomCardProps> = ({
  title,
  content,
  spanData,
  headClass = "pb-0",
  colSize = "xl-6",
  style
}) => {
  return (
    <Col xl={colSize}>
      <Card
        style={{
          // boxShadow: "4px 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          ...style
        }}
      >
        <CardHeaderCommon
          title={title}
          span={
            Array.isArray(spanData)
              ? spanData.map((item) => ({ text: item.text }))
              : undefined
          }
          headClass={headClass}
        />
        <CardBody>
          {content}{" "}
          {/* ✅ Accepts JSX, so we don’t need to wrap it inside a <P> tag */}
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomCard;
